export enum ArtStyleEnum {
  Art3D,
  Art2D
}

export enum Tenant {
  G7 = 'Game7',
  ZkSync = 'zkSync'
}

export enum Hosts {
  G7 = 'app.game7.io',
  G7Staging = 'staging.summon.xyz',
  ZkSync = 'zksync.summon.xyz',
  ZkSyncStaging = 'zksync-staging.summon.xyz'
}

export enum Environment {
  Staging = 'staging',
  Production = 'production'
}

export enum AssetsPrefix {
  G7 = 'https://assets.summon.xyz/game7/portal',
  ZkSync = 'https://assets.summon.xyz/zksync/portal'
}

export enum LevelUpVersion {
  V1,
  V2
}
